import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const ObservanceIcon = ({
  width = 48,
  color = 'foraBlue',
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
      <defs>
        <path id="prefix__a" d="M0.986 0.709L11.432 0.709 11.432 11.154 0.986 11.154z" />
        <path id="prefix__b" d="M0 0.544L44.571 0.544 44.571 39.545 0 39.545z" />
        <path id="prefix__c" d="M0 0.1L18.406 0.1 18.406 41.581 0 41.581z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(17.5 10) translate(25.91 .655)" />
          <g transform="translate(17.5 10) translate(0 19.746)" />
        </g>
        <g>
          <g transform="translate(10.314 10) translate(0 17.359)">
            <path
              fill={getSemanticTextColor(color)}
              d="M6.044 1.66c-2.473 0-4.483 1.918-4.483 4.273v11.623c0 1.684 1.054 3.217 2.683 3.909l.475.2v15.092c0 1.8 1.54 3.263 3.431 3.263h2.106c1.892 0 3.431-1.463 3.431-3.263V21.665l.475-.2c1.63-.692 2.683-2.225 2.683-3.91V5.934c0-2.355-2.01-4.272-4.483-4.272H6.044zm4.212 39.92H8.15c-2.752 0-4.992-2.161-4.992-4.823V22.675C1.224 21.655 0 19.698 0 17.555V5.934C0 2.718 2.71.1 6.044.1h6.318c3.333 0 6.044 2.618 6.044 5.833v11.623c0 2.142-1.223 4.1-3.158 5.119v14.082c0 2.662-2.24 4.824-4.992 4.824z"
            />
          </g>
          <path
            fill={getSemanticTextColor(color)}
            d="M9.203 7.385c-2.04 0-3.7 1.58-3.7 3.52s1.66 3.52 3.7 3.52 3.7-1.58 3.7-3.52-1.66-3.52-3.7-3.52m0 8.601c-2.9 0-5.26-2.279-5.26-5.081 0-2.802 2.36-5.081 5.26-5.081s5.26 2.279 5.26 5.081c0 2.802-2.36 5.081-5.26 5.081M54.71 25.22h-5.007c-2.297 0-4.173 1.801-4.173 4.004v9.215c0 1.635 1.033 3.046 2.504 3.666V53.66c0 1.763 1.503 3.204 3.338 3.204h1.67c1.834 0 3.338-1.441 3.338-3.204V42.105c1.47-.62 2.504-2.031 2.504-3.666v-9.215c0-2.203-1.878-4.004-4.173-4.004M52.206 16.808c1.962 0 3.551 1.526 3.551 3.409 0 1.883-1.589 3.408-3.551 3.408-1.96 0-3.55-1.525-3.55-3.408s1.59-3.41 3.55-3.41M35.912 12.588H28.42c-3.434 0-6.244 2.697-6.244 5.994v13.786c0 2.445 1.547 4.559 3.748 5.488v17.292c0 2.635 2.246 4.794 4.994 4.794h2.497c2.748 0 4.997-2.16 4.997-4.794V37.856c2.198-.93 3.746-3.043 3.746-5.488V18.582c0-3.297-2.81-5.994-6.245-5.994M32.165 0c-2.933 0-5.312 2.284-5.312 5.102 0 2.816 2.379 5.101 5.312 5.101 2.936 0 5.315-2.285 5.315-5.101C37.48 2.284 35.101 0 32.165 0"
            transform="translate(10.314 10)"
          />
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
